// @flow
import React from 'react';
import { If } from '@presentational/If';

import { VBDRibbonContainer } from '../common/vbd/VBDRibbonContainer';

import { MLDUserTagRibbonContainer } from './MLDUserTagRibbonContainer';

export const MLDVBDAndUserStatusTagContainer = ({
  doesVBDRowConflictWithAnyOtherUserRow,
  isVBDRow,
  rowValues,
}) => {
  return (
    <>
      <If test={!isVBDRow}>
        <MLDUserTagRibbonContainer rowValues={rowValues} />
      </If>
      <If test={isVBDRow}>
        <VBDRibbonContainer
          doesVBDRowConflictWithAnyOtherUserRow={doesVBDRowConflictWithAnyOtherUserRow}
        />
      </If>
    </>
  );
};
